module.exports = __webpack_public_path__ + "static/media/logo.eab2ad54.svg";